export const MutationTypeList = {
    SET_WORKER_LIST: 'SET_WORKER_LIST',
    SET_WORKER_SELECTED_HUB: 'SET_WORKER_SELECTED_HUB',
    SET_WORKER: 'SET_WORKER',
    SET_FULFILLMENT_TABLE: 'SET_FULFILLMENT_TABLE',
    INCREASE_TEST_VALUE: 'INCREASE_TEST_VALUE',
};
const mutations = {
    [MutationTypeList.SET_WORKER_LIST](state, payload) {
        state.workerList = payload;
    },
    [MutationTypeList.SET_WORKER_SELECTED_HUB](state, selectedHub) {
        state.workerSelectedHub = selectedHub;
    },
    [MutationTypeList.SET_WORKER](state, worker) {
        state.worker = worker;
    },
    [MutationTypeList.SET_FULFILLMENT_TABLE](state, fulfillmentTable) {
        state.fulfillmentTable = fulfillmentTable;
    },
    // INFO ts 테스트용
    [MutationTypeList.INCREASE_TEST_VALUE](state, value) {
        state.testValue += value;
    },
};
export default mutations;
